import React, { Component } from "react";


function withHistory(WrappedComponent, ...props) {
	const history = window.history;

	return class extends Component {

		handleLocationChange = (e) => {
			return e;
		}

		componentDidMount() {
			window.addEventListener('popstate',this.handleLocationChange)
		}

		componentWillUnmount() {
			window.removeEventListener('popstate',this.handleLocationChange)
		}

		render() {
			return <WrappedComponent {...this.props} {...props} history={history} locationChanged={this.handleLocationChange} />
		}
	}

}

export default withHistory;